<div
  class="flex w-full flex-1 flex-col items-center justify-center gap-6 py-12"
  role="status"
  aria-live="polite"
>
  <div class="relative h-24 w-24" aria-hidden="true">
    <!-- Anel externo rosa neon -->
    <div
      class="neon-glow-pink absolute inset-0 animate-spin rounded-full border-4 border-primary-container/20 border-t-primary-container"
    ></div>
    <!-- Anel interno ciano girando no sentido oposto -->
    <div
      class="neon-glow-cyan absolute inset-4 animate-spin rounded-full border-4 border-secondary-container/20 border-b-secondary-container [animation-direction:reverse] [animation-duration:1.5s]"
    ></div>
  </div>

  @if (message(); as text) {
    <p class="animate-pulse font-label-mono text-sm uppercase tracking-widest text-on-surface-variant">
      {{ text }}
    </p>
  } @else {
    <span class="sr-only">Carregando</span>
  }
</div>
